import type { Paywall } from "@/react/types/Paywall";
import type { Space } from "@/react/types/Space";
import { displayPaywallPrice } from "@circle-react/helpers/paywallPriceHelpers";
import { DataTable } from "@circle-react-uikit/DataTable";
import { PaywallContextualMenu } from "./PaywallContextualMenu";
import { PaywallStatusBadge } from "./PaywallStatusBadge";
import { COLUMN_NAMES } from "./constants";
import { gatedBy, isAssignedToSpace } from "./helpers";

// Extended paywall interface that includes space and space group assignments
interface PaywallWithAssignments extends Paywall {
  space_group_ids: number[];
  space_ids: number[];
}

interface PaywallListProps {
  onRemove: (paywall: Paywall) => void;
  paywalls: PaywallWithAssignments[];
  refetchPaywalls: () => void;
  space: Space;
}

export const PaywallList = ({
  paywalls,
  space,
  onRemove,
  refetchPaywalls,
}: PaywallListProps) => {
  if (paywalls.length === 0) {
    return null;
  }

  const spaceGroupsPaywallsData = paywalls.map(paywall => ({
    key: paywall.id.toString(),
    rowClassName: "group",
    display_name: paywall.display_name,
    unlocked_by: gatedBy(paywall, space),
    pricing: displayPaywallPrice(paywall),
    status: <PaywallStatusBadge paywall={paywall} />,
    actions: (
      <PaywallContextualMenu
        paywall={paywall}
        showRemove={isAssignedToSpace(paywall, space)}
        refetchPaywalls={refetchPaywalls}
        onRemove={onRemove}
      />
    ),
  }));

  return (
    <DataTable
      variant="no-border"
      className="mt-2 lg:mt-2"
      columns={COLUMN_NAMES}
      dataSource={spaceGroupsPaywallsData}
    />
  );
};
